import { render, staticRenderFns } from "./shetu.vue?vue&type=template&id=22794514&"
import script from "./shetu.vue?vue&type=script&lang=ts&"
export * from "./shetu.vue?vue&type=script&lang=ts&"
import style0 from "./shetu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports